import { TYPES } from "./default_wallet.type";
import { onSnapshot, doc } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";
import { getApp } from "firebase/app";

const app = getApp();
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider
const allDefaultWalletSub = [];
export const snapDefaultWallet = (callback) => (dispatch) => {
  setDefaultWalletAllSuccess(dispatch, null);
  const cRef = getRefs().wallet;
  const uid = auth?.currentUser?.uid;
  const qRef = doc(cRef, uid);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.data();
      console.log("snap wallet:" + JSON.stringify(data));
      setDefaultWalletAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultWalletSub.push(unsub);
};

export const unSnapDefaultWallet = () => (dispatch) => {
  allDefaultWalletSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultWalletSub.length = 0;
};
// ========= cloud function =========//
// ========= local function =========//
export const setDefaultWalletAll = (data, callback) => (dispatch) => {
  setDefaultWalletAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};
// ========= dispatch =========//

const setDefaultWalletAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_WALLET_ALL,
    payload: data,
  });
};
